module.exports = "<ng-container *ngIf=\"content | asyncTimer as row_content\">\n    <ng-container *ngIf=\"row_content.meta && row_content.meta.render_style == 'marquee' && !isPhone\">\n            <detail-row class=\"top-section--dark\" [item]=\"row_content.meta\" [showImage]=\"false\" [truncateText]=\"false\"></detail-row>\n    </ng-container>\n    <rows [rows$] = \"row_content.rows\" ></rows>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/containers/grid-container/grid-container.component.html
// module id = 862
// module chunks = 2